/**
 * +castux: spell-queue window maths (pure). The sim queues a press made while the current cast /
 * channel / GCD has at most SPELL_QUEUE_WINDOW_MS left (packages/sim core/casting.ts), so the HUD
 * shades that last stretch on the player cast bar, the GCD sweep and the cast ring.
 */
import { SPELL_QUEUE_WINDOW_MS } from '@keystone/sim';

export { SPELL_QUEUE_WINDOW_MS };

/** Fraction (0..1) of a bar / sweep of `totalMs` that is the queue window. 0 for an empty duration. */
export function queueFraction(totalMs: number, windowMs: number = SPELL_QUEUE_WINDOW_MS): number {
  if (!(totalMs > 0)) return 0;
  return Math.min(1, windowMs / totalMs);
}

/** A press now would queue (something is still running, and it ends within the window). */
export function inQueueWindow(remainingMs: number, windowMs: number = SPELL_QUEUE_WINDOW_MS): boolean {
  return remainingMs > 0 && remainingMs <= windowMs;
}
